import { useTranslate } from "@similarweb/i18n-provider";
import { DynamicIllustration } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { useHasAnyPendingCrmIndustryTransition } from "../../hooks/useHasAnyPendingCrmIndustryTransition";
import { industryTransitionKeys } from "../../utils/i18n";

import { EnrollFollowUpNotice } from "./EnrollFollowUpNotice";

const ILLUSTRATION_SIZE = 160;

/** No "Done" action: the header's close control is the way out of this screen. */
type EnrollSuccessViewProps = {
    readonly onViewLeadGeneration: () => void;
    readonly onGoToCrmSettings: () => void;
};

export const EnrollSuccessView = ({ onViewLeadGeneration, onGoToCrmSettings }: EnrollSuccessViewProps) => {
    const { translate } = useTranslate();
    const showsCrmFollowUp = useHasAnyPendingCrmIndustryTransition();

    return (
        <Flex
            flex="1"
            alignItems="center"
            justifyContent="center"
            padding="32px"
        >
            <Stack
                gap="16px"
                alignItems="center"
                data-automation="industry-transition-impact-report-success"
            >
                <DynamicIllustration
                    illustrationName="HighfiveBlue"
                    size={ILLUSTRATION_SIZE}
                />

                <Text
                    fontVariant="subtitle1"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate(industryTransitionKeys.successTitle)}
                </Text>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate(industryTransitionKeys.successDescription)}
                </Text>

                {showsCrmFollowUp ? <EnrollFollowUpNotice /> : null}

                <Flex
                    gap="12px"
                    alignItems="center"
                    justifyContent="center"
                    flexWrap="wrap"
                >
                    <Button
                        type={showsCrmFollowUp ? "flat" : "primary"}
                        onClick={onViewLeadGeneration}
                        data-automation="industry-transition-impact-report-success-lead-generation"
                    >
                        {translate(industryTransitionKeys.successViewLeadGeneration)}
                    </Button>
                    {showsCrmFollowUp ? (
                        <Button
                            onClick={onGoToCrmSettings}
                            data-automation="industry-transition-impact-report-success-crm-settings"
                        >
                            {translate(industryTransitionKeys.successCrmSettings)}
                        </Button>
                    ) : null}
                </Flex>
            </Stack>
        </Flex>
    );
};
